import React, { useEffect, useState } from 'react'

const FALLBACK_URL = 'https://baigongai.cn/download/youlabberlocal/YouLabberLocal-Setup-latest.exe'
const RELEASE_URL = 'https://baigongai.cn/download/youlabberlocal/release.json'
const GUIDE_URL = 'https://baigongai.cn/download/youlabberlocal/install.html'

function formatSize(size) {
  if (!Number.isFinite(size) || size <= 0) return ''
  const mb = size / (1024 * 1024)
  return mb >= 1024 ? `${(mb / 1024).toFixed(1)} GB` : `${Math.ceil(mb)} MB`
}

export function useYouLabberLocalRelease() {
  const [release, setRelease] = useState({ url: FALLBACK_URL, version: '', sizeText: '', sha256: '' })
  useEffect(() => {
    let alive = true
    fetch(RELEASE_URL, { cache: 'no-store' })
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        if (!alive || !data) return
        setRelease({
          url: data.url || FALLBACK_URL,
          version: data.version || '',
          sizeText: formatSize(Number(data.size)),
          sha256: data.sha256 || '',
        })
      })
      .catch(() => {})
    return () => { alive = false }
  }, [])
  return release
}

export function YouLabberLocalDownloadCard() {
  const release = useYouLabberLocalRelease()
  return (
    <div className="hwb-section" style={{ margin: '12px 0 0', padding: 12 }}>
      <div style={{ fontWeight: 700, marginBottom: 6 }}>在自己的电脑完成本作业</div>
      <p style={{ margin: '0 0 8px', fontSize: 13, lineHeight: 1.6 }}>
        安装 YouLabberLocal，在本机运行实验员，完成后可直接从侧边栏提交。
        {release.version ? ` 当前版本 ${release.version}` : ''}
        {release.sizeText ? `，约 ${release.sizeText}` : ''}。
      </p>
      <a className="hwb-link-btn" href={release.url} style={{ marginRight: 12 }}>下载 Windows 版</a>
      <a className="hwb-link-btn" href={GUIDE_URL} target="_blank" rel="noreferrer">安装指南</a>
      {release.sha256 ? <div style={{ marginTop: 8, fontSize: 12, wordBreak: 'break-all' }}>SHA-256：{release.sha256}</div> : null}
    </div>
  )
}

export function YouLabberLocalDownloadBanner() {
  const release = useYouLabberLocalRelease()
  return (
    <div style={{
      marginTop: 16,
      padding: '12px 16px',
      borderRadius: 10,
      border: '1px solid rgba(110,168,254,0.45)',
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      fontSize: 13,
    }}>
      <span style={{ flex: 1, lineHeight: 1.5 }}>
        在自己的电脑使用 YouLabberLocal。
        {release.version ? ` 版本 ${release.version}` : ''}
        {release.sizeText ? `，约 ${release.sizeText}` : ''}
      </span>
      <a href={release.url} style={{ fontWeight: 600 }}>下载 Windows 版</a>
      <a href={GUIDE_URL} target="_blank" rel="noreferrer">安装指南</a>
    </div>
  )
}
